import { ActionReducerMap } from "@ngrx/store";
import { IAppState } from "../states/app.state";
import { ProductReducers } from "./product.reducer";
import { MerchantReducers } from "./merchant.reducer";
import { CategoriesReducers } from "./category.reducer";
import { SubCategoriesReducers } from "./sub-category.reducer";

export const appReducers: ActionReducerMap<IAppState, any> = {
  product: ProductReducers,
  allProduct: ProductReducers,
  categories: CategoriesReducers,
  subcategories: SubCategoriesReducers,
  merchant: MerchantReducers,
};
